<div class="w-full">
  <div class="flex items-center gap-5">
    <button class="border-none outline-none mt-1" (click)="backButton()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <span class="text-base leading-6 font-medium text-qaroni-text-primary">{{
      text
    }}</span>
  </div>
</div>
